<template>
  <div class="weekly-view-man-hour-management w-full max-w-full min-w-0">
    <b-tabs
      v-model="activeTab"
      type="is-boxed"
      class="weekly-view-man-hour-management__tabs"
    >
      <b-tab-item :label="$t('consolidated_quantities_template')">
        <weekly-view-takeoff-boq
          v-if="activeTab === 0"
          :project-id="projectId"
        />
      </b-tab-item>

      <b-tab-item :label="$t('weekly_quantities_template')">
        <weekly-view-weekly-quantities-template
          v-if="activeTab === 1"
          :project-id="projectId"
          :week-number="weekNumber"
          :week-start-date="weekStartDate"
          :week-end-date="weekEndDate"
          :project-weeks="projectWeeks"
        />
      </b-tab-item>

      <b-tab-item :label="$t('hour_premises')">
        <weekly-view-hour-premises
          v-if="activeTab === 2"
          :project-id="projectId"
        />
      </b-tab-item>

      <b-tab-item :label="$t('dashboard_hh')">
        <weekly-view-dashboard-hh
          v-if="activeTab === 3"
          :project-id="projectId"
          :week-number="weekNumber"
          :week-start-date="weekStartDate"
          :week-end-date="weekEndDate"
          :project-weeks="projectWeeks"
        />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import WeeklyViewTakeoffBoq from './weekly-view-takeoff-boq.vue'
import WeeklyViewWeeklyQuantitiesTemplate from './weekly-view-weekly-quantities-template.vue'
import WeeklyViewHourPremises from './weekly-view-hour-premises.vue'
import WeeklyViewDashboardHh from './weekly-view-dashboard-hh.vue'

export default {
  name: 'weekly-view-man-hour-management',

  components: {
    WeeklyViewTakeoffBoq,
    WeeklyViewWeeklyQuantitiesTemplate,
    WeeklyViewHourPremises,
    WeeklyViewDashboardHh,
  },

  props: {
    projectId: {
      type: [Number, String],
      default: null,
    },
    weekNumber: {
      type: Number,
      default: null,
    },
    weekStartDate: {
      type: String,
      default: null,
    },
    weekEndDate: {
      type: String,
      default: null,
    },
    projectWeeks: {
      type: Array,
      default() {
        return []
      },
    },
  },

  data() {
    return {
      activeTab: 0,
    }
  },
}
</script>

<style scoped>
.weekly-view-man-hour-management__tabs :deep(.tab-content) {
  padding: 0.75rem 0 0;
}
</style>
